import React, { Suspense } from "react";
import { Card, Grid } from "@material-ui/core";
import WinACVAnalysis from "./WinACVAnalysis/WinACVAnalysis";
import WinACVMixGaapAnalysis from "./WinACVMixGAAPAnalysis/WinACVMixGaapAnalysis";
import PBIPipelineView from "./PBIPipelineView/PBIPipelineView";
import WonACVMekkoChart from "./PBISummaryView/WonACVMekkoChart";
import PipelineMekkoChart from "./PBIPipelineView/PipelineMekkoChart";
import PBISummaryView from "./PBISummaryView/PBISummaryView";
import NewACVMixAnalysis from "./WinACVMixAnalysis/WinACVMixAnalysis";
import AverageDealSize from "./WinACVMixAnalysis/AverageDealSize";
import PipelineMixAnalysis from "./PipelineMixAnalysis/PipelineMixAnalysis";
import PipelineCreatedAnalysis from "./PipelineMixAnalysis/PipelineCreatedAnalysis";
import PipelineCreatedMixAnalysis from "./PipelineMixAnalysis/PipelineCreatedMixAnalysis";
import BuildingPipeline from "./PipelineMixAnalysis/BuildingPipeline";
import CompetitorPerformance from "./CompetitorPerformance/CompetititorPerformance";
import { PipelineTrends } from "./PipelineTrends/PipelineTrends";
import { PipelineTrendsRolling } from "./PipelineTrends/PipelineTrendsRolling";
import ShowPlotly from "./OppotunityPyramid/ShowPlotly";
import StageProgression from "./StageProgressionAnalysis/StageProgressionAnalysis";
import QuotaMaintenance from "./Quota Maintenance/QuotaMaintenance";
// import QuotaMaintenanceV2 from "./Quota MaintenanceV2/QuotaMaintenanceV2";
import { PcdMovedAnalysis } from "./PCD Moved Analysis/PcdMovedAnalysis";
import { Funnel } from "./Funnel/Funnel";
import { DemandGen } from "./DemandGen/DemnadGenTemp";
import { POCDataChart } from "./DemandGen/POCsSummaryChart";
import { KeyMetrics } from "./Key Metrics/KeyMetrics";
import { MomentumAnalysis } from "./Momentum Analysis/MomentumAnalysis";
import ForecastRollup from "./ForecastRollup/ForecastRollup";
import { Funnel as CreatedFunnel } from "./CreatedFunnel/Funnel";
import FunnelNew from "./NewFunnel/Funnel";
import { Waterfall } from "./Waterfall/Waterfall";
import { Waterfall as NewWaterfall } from "./NewWaterFall/Waterfall";
import { PerformanceByIndustry } from "./PerformanceByIndustry/PerformanceByIndustry";
import { CurrentState } from "./CurrentState/CurrentState";
import { ClosedLost } from "./ClosedLost/ClosedLost";
import { WinRate } from "./WinRate/WinRate";
import { StrengthOfSales } from "./StrengthOfSales/StrengthOfSales";
import SankeyPoc from "./SankeyPoc/SankeyPoc";
import { withStyles } from "@material-ui/core/styles";
import { ConversionEfficiencyBySource } from "../RepPerformance/TimeSeriesPrediction/ConversionEfficiencyBySource";
import { ConversionEfficiencyBySourceByMonth } from "../RepPerformance/TimeSeriesPrediction/ConversionEfficiencyBySourceByMonth";
import { TimeSeriesPredictionv2 } from "../RepPerformance/TimeSeriesPrediction/TimeSeriesPredictionv2";
import { TimeSeriesPredictionByMonth } from "../RepPerformance/TimeSeriesPrediction/TimeSeriesPredictionByMonth";
import PSCA from "../RepPerformance/PSCA/PSCA";
import PGSA from "../RepPerformance/PSCA/PGSA";
import TorqNewDashboard from "../RepPerformance/PSCA/TorqNewDashboard";
import CallsCompleted from "./CallsCompleted/CallsCompleted";
import POcsSummary from "./POCsSummary/POCsSummary";
import DealRegistrationScorecard from "./POCsSummary/DealRegistarationPOCsSummary";
import ChannelMetrics from "./ChannelMetrics/ChannelMetrics";
import ProductsByAccount from "./ProductsByAccount/ProductsByAccount";
import ProductsByAccount2025 from "./ProductsByAccount/ProductsByAccount2025";
import ProductsByAccount2026 from "./ProductsByAccount/ProductsByAccount2026";
import AccountExpansion from "./AccountExpansion/AccountExpansion";
import PIpelineProgression from "./PipelineProgression/PipelineProgression";
import CurrentStateOfQualifiedPipeline from "./CurrentStateOfQualifiedPipeline/CurrentStateOfQualifiedPipeline";
// Rep Performance Routes
import RegionPerformance from "../RepPerformance/RegionPerformance/RegionPerformance";
import SegmentPerformance from "../RepPerformance/RegionPerformance/SegmentPerformance";
import TeamAttainment from "../RepPerformance/TeamAttainment/TeamAttainment";
import { Bar } from "../RepPerformance/Bar/Bar";
import { MultiXAxisBarWithMarker } from "../RepPerformance/MultiXAxisBarWithMarker/MultiXAxisBarWithMarker";
import { ConnectedManagerSummary } from "../RepPerformance/ManagerSummary/ManagerSummary";
import { PerformanceBySalesStage } from "../RepPerformance/PerformanceBySalesStage/PerformanceBySalesStage";
import NewQualifiedPipeline from "../RepPerformance/NewQualifiedPipelineHTML/NewQualifiedPipeline";
import NewQualifiedPipelinev2 from "../RepPerformance/NewQualifiedPipelineHTML/NewQualifiedPipelinev2";
import NewQualifiedPipelinev3 from "../RepPerformance/NewQualifiedPipelineHTML/NewQualifiedPipelinev3";
import { AsOfDate } from "../RepPerformance/AsOfDate/AsOfDate";

import { RepPerformanceAnalysis } from "../RepPerformance/RepPerformanceAnalysis/RepPerformanceAnalysis";

import WhiteSpaceConversionEngine from "./WhiteSpaceConversionEngine/WhiteSpaceConversionEngine";

import QuotaAttainment from "../RepPerformance/QuotaAttainment/QuotaAttainment";
// import QuotaAttainmentV2 from "../RepPerformance/QuotaAttainment/QuotaAttainment/QuotaAttainmentV2";
import QuotaAttainmentV2 from "../RepPerformance/QuotaAttainment/QuotaAttainmentV2";
import QuotaAttainmentV3 from "../RepPerformance/QuotaAttainment/QuotaAttainmentV3";
import QuotaAttainmentMonthly from "../RepPerformance/QuotaAttainment/QuotaAttainmentMonthly";
import RampAnalysis from "../RepPerformance/RampAnalysis/RampAnalysis";
import RepBenchmarking from "../RepPerformance/FunnelCompare/RepBenchmarking";
import RepCertification from "../RepPerformance/RepCertification/RepCertification";
import { TimeSeriesPrediction } from "../RepPerformance/TimeSeriesPrediction/TimeSeriesPrediction";

import { EnablementEffectiveness } from "../RepPerformance/EnablementEffectiveness/EnablementEffectiveness";
import RevenueCommandCenter from "../RevenueCommandCenter/Index";
import GenericBalancedScoreCard from "../RepPerformance/GenericScorecard/BalancedScorecardComponent";
import { Skeleton } from "@material-ui/lab";
import MarketingRequests from "./ProductsByAccount/MarketingRequests";
import GeneratePDF from "../Dashboard/GeneratePdf";
import UserManagementSection from "../Settings/UserManagement/UserManagement";
import { MQLandHandRaisers } from "./MQLandHandRaisers/MQLandHandRaisersAnalysis";
import { AcctSegmentPerf } from "./AcctSegmentPerf/AcctSegmentPefAnalysis";
import ChurnAnalysis from "../CustomerSuccess/Pages/ChurnAnalysis/ChurnAnalysis";
// import AttachRate from "./AttachRate/AttachRate";
import AttachRate from "../ProductInsights/AttachRate/AttachRate";
import UpsetPlotPage from "../RepPerformance/PSCA/UpsetPlotPage";
import PerformanceAlertsMock from "../Dashboard/emailAlert";
import RegionalSalesReviewPackage from "./RegionalSalesReviewPackage/RegionalSalesReviewPackage";
import PipelineReviewPackage from "./PipelineReviewPackage/PipelineReviewPackage";
import RegionalRSMPerformanceSummary from "./RegionalRSMPerformanceSummary/RegionalRSMPerformanceSummary";
import FocusRecommendation from "../Settings/FocusRecommendation/FocusRecommendation";

const PerformanceAlerts = React.lazy(() => import("../PerformanceAlerts"));

const C0001_ScoreCard = React.lazy(() =>
  import("../RepPerformance/ScoreCard/ScoreCard")
);
const C0002_ScoreCard = React.lazy(() =>
  import("../RepPerformance/ScoreCard/C0002_ScoreCard")
);
const C0004_ScoreCard = React.lazy(() =>
  import("../RepPerformance/ScoreCard/C0004_ScoreCard")
);
const ScoreCardNew = React.lazy(() =>
  import("../RepPerformance/ScoreCard/ScoreCardNew")
);

const ScoreCardNew_v2 = React.lazy(() =>
  import("../RepPerformance/ScoreCard/Performance_Scorecard_v2")
);
const GenericScorecard = React.lazy(() =>
  import("../RepPerformance/GenericScorecard/PerformanceScorecard")
);
const GenericScorecardCT = React.lazy(() =>
  import("../RepPerformance/GenericScorecard/PerformanceScorecardCT")
);
const GenericScorecardTorq = React.lazy(() =>
  import("../RepPerformance/GenericScorecard/PerformanceScorecardTorque")
);
const GenericRepScorecard = React.lazy(() =>
  import("../RepPerformance/GenericScorecard/RepScorecard")
);
const BDRsDashboard = React.lazy(() =>
  import("../RepPerformance/GenericScorecard/BDRsDashboard")
);

const ProjectedPipeline = React.lazy(() =>
  import("./ProjectedPipeline/ProjectedPipeline")
);
const TopDealsSummary = React.lazy(() =>
  import("./ProjectedPipeline/TopDealsSummary")
);
const C0003_ProjectedPipeline = React.lazy(() =>
  import("./ProjectedPipeline/C0003_ProjectedPipeline")
);
const C0002_ProjectedPipeline = React.lazy(() =>
  import("./ProjectedPipeline/C0002_ProjectedPipeline")
);
const C0004_ProjectedPipeline = React.lazy(() =>
  import("./ProjectedPipeline/C0004_ProjectedPipelineAnalysis")
);
const styles = (theme) => ({
  dashOuter: {
    display: "flex",
    flexGrow: 1,
    margin: "auto",
  },
  dashInner: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  graph1: {
    flexGrow: 1,
    height: 250,
    margin: 10,
  },
});
const OtherInsightsRoutes = (props) => {
  const { classes } = props;

  return (
    <>
      {props.location ===
        `${props.Win_Rate_Prefix} Cohort Analysis – Closed Deals` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <Funnel />
          </Grid>
        </Grid>
      )}
      {props.location === "Demand Gen Effectiveness" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <DemandGen />
          </Grid>
        </Grid>
      )}
      {props.location === "POCs Summary (Torq)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <POCDataChart />
          </Grid>
        </Grid>
      )}
      {props.location === "Momentum Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <MomentumAnalysis />
          </Grid>
        </Grid>
      )}
      {props.location === "Forecast Roll Up" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ForecastRollup />
          </Grid>
        </Grid>
      )}
      {props.location === "Pipeline Progression Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <CurrentStateOfQualifiedPipeline />
          </Grid>
        </Grid>
      )}
      {props.location === "Projected Close Date Moves" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <PcdMovedAnalysis />
          </Grid>
        </Grid>
      )}

      {props.location === "Pipeline Waterfall Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <NewWaterfall />
          </Grid>
        </Grid>
      )}
      {props.location === "Account Value Expansion" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <AccountExpansion />
          </Grid>
        </Grid>
      )}
      {props.location === "Quota Maintenance" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QuotaMaintenance />
          </Grid>
        </Grid>
      )}

      {props.location === "User Management" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <UserManagementSection />
          </Grid>
        </Grid>
      )}

      {props.location === "Account Segments Performance Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <AcctSegmentPerf />
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Quota Maintenance V2" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QuotaMaintenanceV2 />
          </Grid>
        </Grid>
      )} */}

      {props.location ===
        `${props.Win_Rate_Prefix} Cohort Analysis – Created Deals` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <FunnelNew />
          </Grid>
        </Grid>
      )}
      {/* {props.location === 'Win Rate Cohort Analysis – Created Deals' &&
            <Grid
              container
              spacing={3}
              className={classes.grid}
            >
              <Grid
                item
                xs={12}
              >
                <CreatedFunnel />
              </Grid>
            </Grid>
          } */}
      {/* {props.location === 'Pipeline Waterfall Analysis' &&
            <Grid
              container
              spacing={3}
              className={classes.grid}
            >
              <Grid
                item
                xs={12}
              >
                <Waterfall />
              </Grid>
            </Grid>
          } */}
      {props.location === "Performance by Industry" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PerformanceByIndustry />}
          </Grid>
        </Grid>
      )}
      {props.location ===
        "Current state of opportunities that came to Qualifying" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<CurrentState />}
          </Grid>
        </Grid>
      )}
      {props.location === "Lost Opportunities Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<ClosedLost />}
          </Grid>
        </Grid>
      )}

      {props.location === `${props.Win_Rate_Prefix} Trends` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<WinRate />}
          </Grid>
        </Grid>
      )}
      {props.location === `Won ${props.Value_Label} Mix Analysis` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<WinACVAnalysis />}
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Won MRR Mix Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<WinACVAnalysis />}
          </Grid>
        </Grid>
      )} */}
      {props.location === "Open Pipeline Mix Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PipelineMixAnalysis />}
          </Grid>
        </Grid>
      )}
      {props.location === "Qualified Pipeline Created Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PipelineCreatedAnalysis />}
          </Grid>
        </Grid>
      )}
      {props.location === "Pipeline Created Mix Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PipelineCreatedMixAnalysis />}
          </Grid>
        </Grid>
      )}
      {props.location === "Building Pipeline to Win" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<BuildingPipeline />}
          </Grid>
        </Grid>
      )}
      {props.location === "Pipeline by Vertical and Apps Cluster" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PBIPipelineView />}
          </Grid>
        </Grid>
      )}
      {props.location ===
        `Won ${props.Value_Label} by Vertical and Apps Cluster` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PBISummaryView />}
          </Grid>
        </Grid>
      )}
      {props.location === `Won ${props.Value_Label} Mekko Chart` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<WonACVMekkoChart />}
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Won MRR Mekko Chart" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<WonACVMekkoChart />}
          </Grid>
        </Grid>
      )} */}
      {props.location === "Qualified Pipeline Cohort Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PIpelineProgression />}
          </Grid>
        </Grid>
      )}

      {props.location === "MQL and Hand Raisers Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <MQLandHandRaisers />
          </Grid>
        </Grid>
      )}

      {props.location === "Pipeline Mekko Chart" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<PipelineMekkoChart />}
          </Grid>
        </Grid>
      )}
      {props.location === "Average Deal Size and Cycle Time" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {props.company === "C0003" ? (
              <NewACVMixAnalysis />
            ) : (
              <AverageDealSize />
            )}
          </Grid>
        </Grid>
      )}

      {props.location === "Strength of Sale" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<StrengthOfSales />}
          </Grid>
        </Grid>
      )}
      {props.location === "Opportunities with near-term close" &&
        props.company === "C0001" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <ProjectedPipeline />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Opportunities with near-term close" &&
        props.company === "C0002" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <C0002_ProjectedPipeline />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Opportunities with near-term close" &&
        props.company === "C0003" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <C0003_ProjectedPipeline />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Opportunities with near-term close" &&
        props.company === "C0004" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <C0004_ProjectedPipeline />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Opportunities with near-term close" &&
        !["C0001", "C0002", "C0003", "C0004"].includes(props.company) && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <ProjectedPipeline />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Top Deals Summary" &&
        !["C0001", "C0002", "C0003", "C0004"].includes(props.company) && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <TopDealsSummary />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Performance against Key Competitors" &&
        props.company !== "C0003" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense fallback={<div>Loading...</div>}>
                  <CompetitorPerformance />
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Pipeline Trends" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense fallback={<div>Loading...</div>}>
                <PipelineTrends />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Cycle Time Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ShowPlotly />
          </Grid>
        </Grid>
      )}
      {props.location === "Pipeline Trends Rolling" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense fallback={<div>Loading...</div>}>
                <PipelineTrendsRolling />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Stage Progression Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <StageProgression />
          </Grid>
        </Grid>
      )}
      {props.location === `Won ${props.Value_Label} Mix GAAP Analysis` && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <WinACVMixGaapAnalysis />
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Won MRR Mix GAAP Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <WinACVMixGaapAnalysis />
          </Grid>
        </Grid>
      )} */}
      {props.location === "Key Metrics" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {<KeyMetrics />}
          </Grid>
        </Grid>
      )}
      {props.location === "Sankey POC" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <SankeyPoc />
          </Grid>
        </Grid>
      )}

      {props.location ===
        "Conversion Efficiency by Source + Growth Modeling" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ConversionEfficiencyBySource />
          </Grid>
        </Grid>
      )}

      {props.location ===
        "Conversion Efficiency by Source + Growth Modeling (Monthly)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ConversionEfficiencyBySourceByMonth />
          </Grid>
        </Grid>
      )}

      {props.location === "Time Series projection of Closed Won" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <TimeSeriesPredictionv2 />
          </Grid>
        </Grid>
      )}

      {props.location === "Time Series projection of Closed Won (Monthly)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <TimeSeriesPredictionByMonth />
          </Grid>
        </Grid>
      )}

      {props.location === "Calls Completed" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <CallsCompleted />
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Performance Alerts" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <PerformanceAlertsMock />
          </Grid>
        </Grid>
      )} */}
      {props.location === "Pipeline Coverage and Shape Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <PSCA />
          </Grid>
        </Grid>
      )}

      {props.location === "Pipeline Goal vs. Actual" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <PGSA />
          </Grid>
        </Grid>
      )}

      {props.location === "HyperSoc vs Hyperautomation" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <TorqNewDashboard />
          </Grid>
        </Grid>
      )}

      {props.location === "POCs Summary" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <POcsSummary />
          </Grid>
        </Grid>
      )}

      {props.location === "Deal Registrations Scorecard (Torq)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <DealRegistrationScorecard />
          </Grid>
        </Grid>
      )}

      {props.location === "Channel Metrics" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ChannelMetrics />
          </Grid>
        </Grid>
      )}

      {props.location === "White Space Conversion Engine" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <WhiteSpaceConversionEngine />
          </Grid>
        </Grid>
      )}

      {props.location === "White Space Analysis + Products by Account" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ProductsByAccount />
          </Grid>
        </Grid>
      )}

      {props.location ===
        "White Space Analysis + Products by Account - 2025" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ProductsByAccount2025 />
          </Grid>
        </Grid>
      )}

      {props.location ===
        "White Space Analysis + Products by Account - 2026" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ProductsByAccount2026 />
          </Grid>
        </Grid>
      )}

      {props.location === "Product Co-usage in the installed base" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <UpsetPlotPage company={props.company} />
          </Grid>
        </Grid>
      )}

      {props.location === "Rep Level Scorecard" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <MultiXAxisBarWithMarker />
          </Grid>
        </Grid>
      )}
      {props.location === "Factors driving top reps" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <Bar />
          </Grid>
        </Grid>
      )}
      {props.location === "Performance by sales stage" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <PerformanceBySalesStage />
          </Grid>
        </Grid>
      )}
      {props.location === "Manager Summary" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ConnectedManagerSummary />
          </Grid>
        </Grid>
      )}
      {props.location === "New Qualified pipeline" &&
        props.company !== "C0013" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              <NewQualifiedPipeline />
            </Grid>
          </Grid>
        )}

      {props.location === "New Qualified pipeline" &&
        props.company === "C0013" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              <NewQualifiedPipelinev3 />
            </Grid>
          </Grid>
        )}
      {props.location === "New Pipeline Creation and Cadence" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <NewQualifiedPipelinev2 />
          </Grid>
        </Grid>
      )}
      {props.location === "Rep Performance Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <RepPerformanceAnalysis />
          </Grid>
        </Grid>
      )}
      {props.location === "Rep Performance YTD" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <AsOfDate />
          </Grid>
        </Grid>
      )}
      {props.location === "Region Performance YTD" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <RegionPerformance />
          </Grid>
        </Grid>
      )}
      {props.location === "Rep Benchmarking Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <RepBenchmarking />
          </Grid>
        </Grid>
      )}

      {props.location === "Generate Quota Letters" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <GeneratePDF />
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Performance Scorecard" &&
                  ["C0001"].includes(props.company) && (
                    <Grid container spacing={3} className={classes.grid}>
                      <Grid item xs={12}>
                        {
                          <Suspense
                            fallback={
                              <Grid
                                item
                                container
                                component={Card}
                                style={{ margin: "1rem" }}
                                justify="center"
                              >
                                <Skeleton
                                  variant="react"
                                  animation="wave"
                                  height={120}
                                  width="90%"
                                  style={{ margin: "1rem" }}
                                />
                              </Grid>
                            }
                          >
                            <C0001_ScoreCard />
                          </Suspense>
                        }
                      </Grid>
                    </Grid>
                  )}
                {props.location === "Performance Scorecard" &&
                  ["C0004"].includes(props.company) && (
                    <Grid container spacing={3} className={classes.grid}>
                      <Grid item xs={12}>
                        {
                          <Suspense
                            fallback={
                              <Grid
                                item
                                container
                                component={Card}
                                style={{ margin: "1rem" }}
                                justify="center"
                              >
                                <Skeleton
                                  variant="react"
                                  animation="wave"
                                  height={120}
                                  width="90%"
                                  style={{ margin: "1rem" }}
                                />
                              </Grid>
                            }
                          >
                            <C0004_ScoreCard />
                          </Suspense>
                        }
                      </Grid>
                    </Grid>
                  )}
                {props.location === "Performance Scorecard" &&
                  ["C0002"].includes(props.company) && (
                    <Grid container spacing={3} className={classes.grid}>
                      <Grid item xs={12}>
                        {
                          <Suspense
                            fallback={
                              <Grid
                                item
                                container
                                component={Card}
                                style={{ margin: "1rem" }}
                                justify="center"
                              >
                                <Skeleton
                                  variant="react"
                                  animation="wave"
                                  height={120}
                                  width="90%"
                                  style={{ margin: "1rem" }}
                                />
                              </Grid>
                            }
                          >
                            <C0002_ScoreCard />
                          </Suspense>
                        }
                      </Grid>
                    </Grid>
                  )}
      
                {props.location === "Performance Scorecard" &&
                  props.company === "C0003" && (
                    <Grid container spacing={3} className={classes.grid}>
                      <Grid item xs={12}>
                        {
                          <Suspense
                            fallback={
                              <Grid
                                item
                                container
                                component={Card}
                                style={{ margin: "1rem" }}
                                justify="center"
                              >
                                <Skeleton
                                  variant="react"
                                  animation="wave"
                                  height={120}
                                  width="90%"
                                  style={{ margin: "1rem" }}
                                />
                              </Grid>
                            }
                          >
                            <ScoreCardNew />
                          </Suspense>
                        }
                      </Grid>
                    </Grid>
                  )} */}
      {props.location === "Segment Historical Performance" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <SegmentPerformance />
          </Grid>
        </Grid>
      )}
      {props.location === "Show Plotly" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <ShowPlotly />
          </Grid>
        </Grid>
      )}
      {/* {props.location === "Quota Attainment Distribution" && (
              <Grid container spacing={3} className={classes.grid}>
                <Grid item xs={12}>
                  {
                    <Suspense
                      fallback={
                        <Grid
                          item
                          container
                          component={Card}
                          style={{ margin: "1rem" }}
                          justify="center"
                        >
                          <Skeleton
                            variant="react"
                            animation="wave"
                            height={120}
                            width="90%"
                            style={{ margin: "1rem" }}
                          />
                        </Grid>
                      }
                    >
                      <QuotaAttainment />
                    </Suspense>
                  }
                </Grid>
              </Grid>
            )} */}
      {props.location === "Quota Attainment Distribution" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                <QuotaAttainmentV2 />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Beginning Of Quarter Qualified Pipe Attainment" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                <QuotaAttainmentV3 />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Quota Attainment Distribution (Monthly)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                <QuotaAttainmentMonthly />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Performance Scorecard" &&
        props.company === "C0003" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense
                  fallback={
                    <Grid
                      item
                      container
                      component={Card}
                      style={{ margin: "1rem" }}
                      justify="center"
                    >
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  }
                >
                  {<ScoreCardNew_v2 />}
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "Certification vs. Performance Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                <RepCertification />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Performance Scorecard (Generic)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<GenericScorecard />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Performance Scorecard (RC)" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<GenericScorecard />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Performance Scorecard" &&
        props.company !== "C0003" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense
                  fallback={
                    <Grid
                      item
                      container
                      component={Card}
                      style={{ margin: "1rem" }}
                      justify="center"
                    >
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  }
                >
                  {<GenericScorecard />}
                </Suspense>
              }
            </Grid>
          </Grid>
        )}

      {props.location === "Performance Scorecard (CT)" &&
        props.company !== "C0003" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense
                  fallback={
                    <Grid
                      item
                      container
                      component={Card}
                      style={{ margin: "1rem" }}
                      justify="center"
                    >
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  }
                >
                  {<GenericScorecardCT />}
                </Suspense>
              }
            </Grid>
          </Grid>
        )}

      {props.location === "Performance Scorecard (Torq)" &&
        props.company !== "C0003" && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} style={{ padding: "0px" }}>
              {
                <Suspense
                  fallback={
                    <Grid
                      item
                      container
                      component={Card}
                      style={{ margin: "1rem" }}
                      justify="center"
                    >
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  }
                >
                  {<GenericScorecardTorq />}
                </Suspense>
              }
            </Grid>
          </Grid>
        )}
      {props.location === "BDR Metrics Summary" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<BDRsDashboard />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Balanced Scorecard" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<GenericBalancedScoreCard />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Rep Performance Scorecard" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<GenericRepScorecard />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Team Attainment" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<TeamAttainment />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Customer Churn Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                <ChurnAnalysis />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Attach rate for Product Add-ons" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                <AttachRate />
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Ramp Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<RampAnalysis />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}

      {props.location === "Marketing Support Requests" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <MarketingRequests />
          </Grid>
        </Grid>
      )}

      {props.location === "Enablement Effectiveness" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<EnablementEffectiveness />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Regional Sales Review Package" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <RegionalSalesReviewPackage />
          </Grid>
        </Grid>
      )}
      {props.location === "Pipeline Review Package" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <PipelineReviewPackage />
          </Grid>
        </Grid>
      )}
      {props.location === "Regional RSM Performance Summary" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <RegionalRSMPerformanceSummary />
          </Grid>
        </Grid>
      )}
      {props.location === "Performance Alerts" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<PerformanceAlerts />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Revenue Command Center" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<RevenueCommandCenter />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
      {props.location === "Opportunities for Increased Focus" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            {
              <Suspense
                fallback={
                  <Grid
                    item
                    container
                    component={Card}
                    style={{ margin: "1rem" }}
                    justify="center"
                  >
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                }
              >
                {<FocusRecommendation />}
              </Suspense>
            }
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default withStyles(styles)(OtherInsightsRoutes);
